import { createSlice } from "@reduxjs/toolkit";
import { getChatHistory } from "../../../thunks/common-thunks/commonThunk";

const initialState = {
  chatHistory: [],
  buyerProductsChatHistory: [],
  campaignProductsChatHistory: [],
  productsChatHistory: [],
};

const chatHistorySlice = createSlice({
  name: "chatHistory",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(getChatHistory.pending, (state) => {
        state.chatLoading = true;
        state.chatError = null;
      })
      .addCase(getChatHistory.fulfilled, (state, action) => {
        state.chatLoading = false;
        state.chatHistory = action.payload.data || [];
        state.buyerProductsChatHistory =
          action.payload?.data?.[0]?.products || [];
        state.campaignProductsChatHistory = action.payload?.data || [];
        state.productsChatHistory = action.payload?.data?.[0]?.products || [];
      })
      .addCase(getChatHistory.rejected, (state, action) => {
        state.chatLoading = false;
        state.chatError = action.payload;
      });
  },
});

export default chatHistorySlice.reducer;
